/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DashboardPropertiesV2API
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the Dashboard Properties
 */
define([], () => {
	class DashboardPropertiesV2API {

		/**
		 * @function DashboardPropertiesV2API#getPropertyLayoutList	
		 * @description get the full expanded properties for all of the selected contents including layout and metadata properties; dashboard and top layout content properties when the selection is empty
		 * @returns {Object} the expanded properties of all
		 */
		getPropertyLayoutList() {}

		/**
		 * @function DashboardPropertiesV2API#getPropertyList
		 * @description get the list of properties for all of the selected contents;
		 * @returns {Object} property list
		 */
		getPropertyList() {}

		/**
		 * @function DashboardPropertiesV2API#getSelectedContentIds
		 * @description get a list of selection content ids
		 * @returns {Object} list of selected content ids
		 */
		getSelectedContentIds() {}


		/**
		 * @function DashboardPropertiesV2API#getContext
		 * @description get the observable properties rendering context 
		 * @returns {Object} the content of rendered properties containers
		 * @example:
		 *  {
		 * 		activeContainer: 'child_211'
		 * 		containers: [ { id: 'parentPanel', label: 'Dashboard properties', ancestors:[] }, { id: 'child_211', label: 'Tab individual properties', ancestors:['parentPanel'] }]
		 * 	}
		 */
		getContext(){}
	}

	return DashboardPropertiesV2API;
});
